import React from 'react'

import { useSTheme } from 'styles/theme'

import SLink from 'components/opinionless/SLink'
import SText from 'components/opinionless/SText'
import { defaultMargin } from '../constants'

type Props = {
    url: string
    text: string
    marginTop?: string
}

const FNeedHelpCTA: React.FC<Props> = (props: Props) => {
    const { url, text } = props
    const theme = useSTheme()
    const fontFamily = theme.fontsV2[window.ORGANIZATION.name]?.body || theme.fontsV2.default

    return (
        <SLink href={url} target="_blank">
            <SText
                color={theme.colors.secondaryColor}
                fontWeight={'700'}
                sx={{
                    marginTop: props.marginTop || defaultMargin,
                    cursor: 'pointer',
                    '&:hover': {
                        textDecoration: 'underline',
                    },
                    fontFamily: fontFamily,
                }}
            >
                {text}
            </SText>
        </SLink>
    )
}

export default FNeedHelpCTA
